(function () {
    const DEBUG = false;

    const COOKIE_NAME = "goodav_block_popup-9226";
    const COOKIE_EXPIRATION_DAYS = 30;

    // URL parameter(s) that enable the bypass.
    const BYPASS_PARAMETERS = {
        age_verified: "1"
    };

    // Exact URL paths that bypass the age gate.
    const BYPASS_PATHS = [
        "/pages/landing",
        "/pages/special-offer"
    ];

    /*
     * Wildcard path examples:
     *
     * const BYPASS_PATH_PREFIXES = [
     *     "/collections/",
     *     "/pages/landing/"
     * ];
     *
     * Then include:
     *
     * const pathPrefixMatch = BYPASS_PATH_PREFIXES.some(prefix =>
     *     window.location.pathname.startsWith(prefix)
     * );
     */

    const params = new URLSearchParams(window.location.search);

    const parameterMatch = Object.entries(BYPASS_PARAMETERS).some(
        ([key, value]) => params.get(key) === value
    );

    const pathMatch = BYPASS_PATHS.includes(window.location.pathname);

    // Example wildcard support:
    // const pathPrefixMatch = BYPASS_PATH_PREFIXES.some(prefix =>
    //     window.location.pathname.startsWith(prefix)
    // );

    if (!(parameterMatch || pathMatch)) {
        return;
    }

    // Don't overwrite an existing verification cookie.
    const hasCookie = document.cookie
        .split(";")
        .some(cookie => cookie.trim().startsWith(COOKIE_NAME + "="));

    if (hasCookie) {
        return;
    }

    const expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_EXPIRATION_DAYS);

    document.cookie =
        COOKIE_NAME +
        "=; expires=" +
        expires.toUTCString() +
        "; path=/; SameSite=Lax";

    if (DEBUG) {
        console.debug(
            "[Age Gate Bypass] Verification cookie created:",
            COOKIE_NAME
        );
    }
})();